/**
 * bold-subscription-accessibility.js
 *
 * Fügt vollständige Tastaturunterstützung (Tab/Enter/Leertaste)
 * zu BOLD Subscription Widget-Radiogruppen (Purchase Options & Delivery Schedule) hinzu,
 * und deaktiviert Pfeiltasten-Navigation, um Verwirrung zu vermeiden.
 * Erkennt das Widget auch, wenn es dynamisch (z.B. im Quick-Shop-Popup) nachgeladen wird.
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1) Initiale Einrichtung aller schon vorhandenen Widgets
  initAllWidgets();

  // 2) MutationObserver, um neu hinzugefügte .bsub-widget-Elemente (z.B. Quick-Shop) zu erkennen
  const bodyObserver = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        // falls der Node selbst ein Widget ist...
        if (node.matches('.bsub-widget')) {
          initWidget(node);
        }
        // ...oder Widgets in seinem Unterbaum enthält
        node.querySelectorAll('.bsub-widget').forEach(initWidget);
      });
    }
  });
  bodyObserver.observe(document.body, { childList: true, subtree: true });
});

/**
 * Initialisiert alle aktuell im DOM vorhandenen Subscription-Widgets.
 */
function initAllWidgets() {
  document.querySelectorAll('.bsub-widget').forEach(initWidget);
}

/**
 * Führt alle Accessibility-Wiring-Schritte für ein einzelnes Widget durch.
 * @param {HTMLElement} widget — das .bsub-widget-Element
 */
function initWidget(widget) {
  // a) Purchase Options (One-time vs Subscription)
  const groupLabels = widget.querySelectorAll('label.bsub-widget__group-label');
  initRadioGroup(groupLabels, 'input[data-bsub-selling-plan-group-input]');

  // b) Delivery Schedule (erscheint nach Wahl von „Subscription“)
  observePlansContainer(widget);
}

/**
 * Verdrahtet eine Reihe von <label>-Elementen als radio button group:
 * - nur Tab/Enter/Leertaste zum Auswählen
 * - Pfeiltasten werden ignoriert
 * @param {NodeListOf<HTMLElement>} labels
 * @param {string} inputSelector  (CSS-Selector für das jeweilige <input> in jedem Label)
 */
function initRadioGroup(labels, inputSelector) {
  const items = Array.from(labels);
  items.forEach(label => {
    const input = label.querySelector(inputSelector);
    if (!input) return;

    // Fokusbar machen & role/aria-checked setzen
    label.setAttribute('tabindex', '0');
    label.setAttribute('role', 'radio');
    label.setAttribute('aria-checked', input.checked);

    // aria-checked updaten, wenn input sich ändert
    input.addEventListener('change', () => {
      items.forEach(lbl => {
        const inp = lbl.querySelector(inputSelector);
        lbl.setAttribute('aria-checked', inp.checked);
      });
    });

    // Klick, Enter oder Leertaste schalten das input
    label.addEventListener('click', () => input.click());
    label.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        input.click();
      }
      // Pfeil-Tasten und alle anderen ignorieren
    });
  });
}

/**
 * Beobachtet das nachgeladene Delivery-Schedule-Fieldset und verdrahtet auch dort
 * die Radiolabels nach demselben Muster.
 */
function observePlansContainer(widget) {
  const plansSelector = '[data-bsub-selling-plans-container]';

  function setupPlans() {
    const container = widget.querySelector(plansSelector);
    if (!container) return;
    const planLabels = container.querySelectorAll('label.bsub-widget__plan-label');
    initRadioGroup(planLabels, 'input[data-bsub-selling-plan-input]');
  }

  // Erstmaliges Verdrahten
  setupPlans();

  // Und erneut, wenn BOLD die Pläne einblendet oder nachlädt
  const mo = new MutationObserver(setupPlans);
  mo.observe(widget, { childList: true, subtree: true });
}
